import React from 'react'
import styled from 'styled-components'

import { TPicture } from '@hozana/styling/image'

import { Div } from 'elements/layout/Div'

import { Image, TImageProps } from './Image'

const StyledImage = styled(Image)<{ hasAspectRatio: boolean }>`
  ${({ hasAspectRatio }) => (hasAspectRatio ? 'position: absolute;' : '')};
`

export const VariableHeightImage: TFCC<TImageProps> = ({ m, ...otherProps }) => {
  const src = (typeof otherProps.src === 'object' ? otherProps.src : {}) as TPicture
  const ratio = otherProps.size?.includes('x') ? otherProps.size : src?.aspectRatio
  const [widthRatio, heightRatio] = ratio?.split(/\D/).map((s) => parseInt(s)) || []

  return (
    // Apply a padding here will allow to anticipate the height of the image until it is loaded.
    <Div maxW="100%" p={`0 0 ${(heightRatio / widthRatio) * 100}%`} m={m}>
      <StyledImage
        {...otherProps}
        hasAspectRatio={heightRatio !== undefined && widthRatio !== undefined}
        maxH="unset"
        h="unset"
      />
    </Div>
  )
}
